import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/esm/objectWithoutProperties";
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/* eslint-disable no-restricted-syntax */

import React from 'react';
import PropType from 'prop-types';
import { Link as RRLink } from 'react-router-dom';
import { Link } from '@govhhs/govhhs-design-system-react';
/**
 * The RouterLink wraps usage of the WDS Link component.
 *
 * @param {any} props the props for the component.
 * @returns the Link component.
 *
 * @namespace RouterLink
 * @memberof RouterLink
 */

var RouterLink = function RouterLink(_ref) {
  var to = _ref.to,
      children = _ref.children,
      otherProps = _objectWithoutProperties(_ref, ["to", "children"]);

  return /*#__PURE__*/React.createElement(Link, _extends({
    link: /*#__PURE__*/React.createElement(RRLink, {
      to: to
    })
  }, otherProps), children);
};

RouterLink.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
  indicates where the link will direct
  */
  children: PropType.node,

  /**
  child elements
  */
  to: PropType.string.isRequired
} : {};
RouterLink.defaultProps = {
  children: undefined
};
/**
 * Wraps a Web Design System Link component and uses this class's **to** prop to form a
 * {@link https://reacttraining.com/react-router/web/api/Link|React Router's Link}
 * component passed to the Web Design System Link component's **link** prop. This is provided to
 * simplify the coding of "Routed" Links which is the general case.
 *
 * @param {string} to indicates where the link will direct.
 */

export default RouterLink;